'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002410 from "./presto.-Agent-View$$anon$10.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002412 from "./presto.-Agent-View$$anon$12.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002414 from "./presto.-Agent-View$$anon$14.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002416 from "./presto.-Agent-View$$anon$16.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002418 from "./presto.-Agent-View$$anon$18.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002420 from "./presto.-Agent-View$$anon$20.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002424 from "./presto.-Agent-View$$anon$24.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002428 from "./presto.-Agent-View$$anon$28.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002430 from "./presto.-Agent-View$$anon$30.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00246 from "./presto.-Agent-View$$anon$6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00248 from "./presto.-Agent-View$$anon$8.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024 from "./presto.-Agent-View$-Closed$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dOpened$0024 from "./presto.-Agent-View$-Opened$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dReceive$002dProtocol from "./presto.-Agent-View$-Receive-Protocol.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$ReceiveProtocol$() {
  this.aAs = null;
  $n_Lpresto_AgentView$ReceiveProtocol$ = this;
  this.aAs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().ag($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_presto$002e$002dAgent$002dView$0024$002dReceive$002dProtocol.$d_Lpresto_AgentView$ReceiveProtocol.r().C)([$j_presto$002e$002dAgent$002dView$0024$002dOpened$0024.$m_Lpresto_AgentView$Opened$(), $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024.$m_Lpresto_AgentView$Closed$(), $j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$()])));
}
export { $c_Lpresto_AgentView$ReceiveProtocol$ as $c_Lpresto_AgentView$ReceiveProtocol$ };
$p = $c_Lpresto_AgentView$ReceiveProtocol$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$ReceiveProtocol$;
/** @constructor */
function $h_Lpresto_AgentView$ReceiveProtocol$() {
}
export { $h_Lpresto_AgentView$ReceiveProtocol$ as $h_Lpresto_AgentView$ReceiveProtocol$ };
$h_Lpresto_AgentView$ReceiveProtocol$.prototype = $p;
$p.cCZ = (function(text) {
  var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_parser_package$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$3, text, new $c_Lpresto_AgentView$ReceiveProtocol$$anon$5(this)).afL($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bL);
});
$p.cES = (function(msg) {
  return (!this.aAs.aE(msg));
});
var $d_Lpresto_AgentView$ReceiveProtocol$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$ReceiveProtocol$, "presto.AgentView$ReceiveProtocol$", ({
  Eo: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_AgentView$ReceiveProtocol$ as $d_Lpresto_AgentView$ReceiveProtocol$ };
var $n_Lpresto_AgentView$ReceiveProtocol$;
function $m_Lpresto_AgentView$ReceiveProtocol$() {
  if ((!$n_Lpresto_AgentView$ReceiveProtocol$)) {
    $n_Lpresto_AgentView$ReceiveProtocol$ = new $c_Lpresto_AgentView$ReceiveProtocol$();
  }
  return $n_Lpresto_AgentView$ReceiveProtocol$;
}
export { $m_Lpresto_AgentView$ReceiveProtocol$ as $m_Lpresto_AgentView$ReceiveProtocol$ };
/** @constructor */
function $c_Lpresto_AgentView$ReceiveProtocol$$anon$5(outer) {
  this.aAB = null;
  this.aAt = null;
  this.aAu = false;
  this.aAC = null;
  this.aAD = false;
  this.aAG = null;
  this.aAz = null;
  this.aAA = false;
  this.aAv = null;
  this.aAw = false;
  this.aAx = null;
  this.aAy = false;
  this.aAE = false;
  this.aAF = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aAB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAG = "ReceiveProtocol";
}
export { $c_Lpresto_AgentView$ReceiveProtocol$$anon$5 as $c_Lpresto_AgentView$ReceiveProtocol$$anon$5 };
$p = $c_Lpresto_AgentView$ReceiveProtocol$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$ReceiveProtocol$$anon$5;
/** @constructor */
function $h_Lpresto_AgentView$ReceiveProtocol$$anon$5() {
}
export { $h_Lpresto_AgentView$ReceiveProtocol$$anon$5 as $h_Lpresto_AgentView$ReceiveProtocol$$anon$5 };
$h_Lpresto_AgentView$ReceiveProtocol$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aAB;
});
$p.L = (function() {
  if ((!this.aAu)) {
    this.aAt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAu = true;
  }
  return this.aAt;
});
$p.O = (function() {
  if ((!this.aAD)) {
    this.aAC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAD = true;
  }
  return this.aAC;
});
$p.E = (function() {
  return this.aAG;
});
$p.t = (function() {
  if ((!this.aAA)) {
    this.aAz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("Opened", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("Closed", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("Error", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("UploadFileRequest", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoSignRequest", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoCertChainRequest", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeCertChainRequest", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileRequest", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileBase64Request", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignHashRequest", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))))));
    this.aAA = true;
  }
  return this.aAz;
});
$p.M = (function() {
  if ((!this.aAw)) {
    this.aAv = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$00246.$c_Lpresto_AgentView$$anon$6(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$00248.$c_Lpresto_AgentView$$anon$8(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002410.$c_Lpresto_AgentView$$anon$10(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002412.$c_Lpresto_AgentView$$anon$12(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002414.$c_Lpresto_AgentView$$anon$14(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002416.$c_Lpresto_AgentView$$anon$16(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002418.$c_Lpresto_AgentView$$anon$18(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002420.$c_Lpresto_AgentView$$anon$20(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002424.$c_Lpresto_AgentView$$anon$24(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002428.$c_Lpresto_AgentView$$anon$28(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))))))))))))))));
    this.aAw = true;
  }
  return this.aAv;
});
$p.Q = (function() {
  if ((!this.aAy)) {
    this.aAx = ($m_Lpresto_AgentView$ReceiveProtocol$(), new $j_presto$002e$002dAgent$002dView$0024$0024anon$002430.$c_Lpresto_AgentView$$anon$30());
    this.aAy = true;
  }
  return this.aAx;
});
$p.w = (function() {
  if ((!this.aAF)) {
    this.aAE = ($m_Lpresto_AgentView$ReceiveProtocol$(), true);
    this.aAF = true;
  }
  return this.aAE;
});
$p.G = (function(c) {
  $m_Lpresto_AgentView$ReceiveProtocol$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeSum__Lio_circe_HCursor__s_util_Either(this, c);
});
var $d_Lpresto_AgentView$ReceiveProtocol$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$ReceiveProtocol$$anon$5, "presto.AgentView$ReceiveProtocol$$anon$5", ({
  Ep: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$ReceiveProtocol$$anon$5 as $d_Lpresto_AgentView$ReceiveProtocol$$anon$5 };
//# sourceMappingURL=presto.-Agent-View$-Receive-Protocol$.js.map
